import React, { useEffect } from "react";
import { ImageAttributes } from "../../Interfaces/IBubbleImagesResponse";
import PrismaZoom from "react-prismazoom";

interface ZoomableFullscreenProps {
  image: ImageAttributes;
  onClose: () => void;
}

const ZoomableFullscreen: React.FC<ZoomableFullscreenProps> = ({
  image,
  onClose,
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  });
  return (
    <div
      className="zoomable-fullscreen"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div className="closeBtn" onClick={onClose}>
        ×
      </div>
      <PrismaZoom>
        <img
          src={image.attributes.url}
          alt="Fullscreen Zoomable"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </PrismaZoom>
    </div>
  );
};

export default ZoomableFullscreen;
